import { useState } from "react";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

//My Components
import AllStudents from "./tables/allStudentsTable";
import ApprovedStudents from "./tables/approvedStudentsTable";
import PendingStudents from "./tables/pendingStudentsTable";

function Students() {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabType = (event, newValue) => {
    setActiveTab(newValue);
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />

      {/* Nav Tabs Here */}
      <Container>
        <Grid container item justifyContent="center" xs={12} lg={12} mx="auto">
          <AppBar position="static">
            <Tabs value={activeTab} onChange={handleTabType}>
              <Tab label="All Students" sx={{ fontWeight: "bold" }} />
              <Tab label="Approved" sx={{ fontWeight: "bold" }} />
              <Tab label="Pending Approvals" sx={{ fontWeight: "bold" }} />
              {/* <Tab label="Supervisors" /> */}
            </Tabs>
          </AppBar>
        </Grid>
      </Container>
      {/* Nav Tabs end Here */}

      <MDBox mb={2} />
      {activeTab === 0 && <AllStudents />}
      {activeTab === 1 && <ApprovedStudents />}
      {activeTab === 2 && <PendingStudents />}
      <MDBox mb={2} />

      <Footer />
    </DashboardLayout>
  );
}

export default Students;
